<div>
  <a [href]="generateHref(listItem?.eventCode, currentRegion, currentLang, listItem?.keyUrlText)">
    <div class="performance-listing" [ngClass]="{ 'is-disabled': listItem?.status === 's02_soldout' }">
      <div class="event-thumb">
        <img [src]="(listItem?.eventImage || '') | secureImage" (error)="onImageError($event)" [class.no-image]="isNoImage(listItem?.eventImage)" [alt]="listItem?.eventName" loading="lazy" />
      </div>
      <div class="event-content">
        <div class="event-title-row">
          <span class="event-name">{{listItem?.eventName}}</span>
          <!-- <span class="time">{{date|localizedDate:timeFormat}}</span> -->
          <mat-basic-chip class="status" [ngClass]="statusClasses()">{{ ('performance.status.' + listItem?.status) | translate }}</mat-basic-chip>
        </div>
        <div class="event-meta">
          <div class="meta-row date-time-row">
            <mat-icon>calendar_month</mat-icon>
            <span>{{date|localizedDate:fullDateFormat}}</span>
            <span class="dot">•</span>
            <mat-icon>schedule</mat-icon>
            <span>{{date|localizedDate:timeFormat}}</span>
          </div>
        </div>
        <div class="event-price-row" *ngIf="(listItem?.minPrice && listItem.minPrice !== '0') || listItem?.priceInfo">
          <mat-icon>local_offer</mat-icon>
          <ng-container *ngIf="listItem?.minPrice && listItem.minPrice !== '0'; else fallbackPrice">
            <span><small class="price-prefix">{{ 'home.labels.pricePrefix' | translate }}</small>{{ listItem?.minPrice | customCurrency }}<small class="price-suffix">{{ 'home.labels.priceSuffix' | translate }}</small></span>
          </ng-container>
          <ng-template #fallbackPrice>
            <span class="price">{{listItem?.priceInfo}}</span>
          </ng-template>
          <mat-basic-chip class="campaign-title" *ngIf="listItem?.campaignTitle">
            {{listItem?.campaignTitle}}
          </mat-basic-chip>
        </div>
      </div>
      <span class="buy-button" [ngClass]="{ 'is-disabled': listItem?.status === 's02_soldout' }">
        {{ 'shared.labels.buy'|translate }}
      </span>
    </div>

    <!-- Mobile Listing -->
    <div class="mobile-performance-listing">
      <div class="date-col">
        <span class="day">{{date|localizedDate:mobileDayFormat}}</span>
        <span class="month">{{date|localizedDate:mobileMonthFormat}}</span>
        <span class="time">{{date|localizedDate:timeFormat}}</span>
        <mat-basic-chip class="status" [ngClass]="statusClasses()">{{ ('performance.status.' + listItem?.status) | translate }}</mat-basic-chip>
      </div>
      <div class="info-col">
        <div class="event-name">{{listItem?.eventName}}</div>
        <div class="event-price-row" *ngIf="(listItem?.minPrice && listItem.minPrice !== '0') || listItem?.priceInfo">
          <mat-icon>local_offer</mat-icon>
          <ng-container *ngIf="listItem?.minPrice && listItem.minPrice !== '0'; else fallbackMobilePrice">
            <span><small class="price-prefix">{{ 'home.labels.pricePrefix' | translate }}</small>{{ listItem?.minPrice | customCurrency }}<small class="price-suffix">{{ 'home.labels.priceSuffix' | translate }}</small></span>
          </ng-container>
          <ng-template #fallbackMobilePrice>
            <span class="price">{{listItem?.priceInfo}}</span>
          </ng-template>
        </div>
        <!-- Placeholder for tags if data becomes available -->
        <!-- <div class="tags">...</div> -->
      </div>
      <div class="action-col">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </div>
  </a>
</div>